import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string = 'OK';
  @Input() btnCancelText: string = 'Cancel';
  @Input() errorType:string;
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    // this.title = this.data.title;
    // this.message = this.data.message;
    // this.errorType = this.data.type
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss(type) {
    this.activeModal.close(false);
  }
  
}
